export default __webpack_public_path__ + "static/straight-cup-red-941a4cecc0f5fd57ab2364e583bc7cae.png";